export default __webpack_public_path__ + "static/media/main hall 1.6093d5af.jpg";